export default [
    {
        path: '/agent/default-margin',
        props: true,
        component: () => import('@/views/Agent/DefaultMargin'),
    },
];
